const TYPE = 'REGISTRATION_SET_DEVICE_ID';

const action = (id) => (dispatch) => dispatch({ type: TYPE, payload: id });

export default { action, TYPE };
